import '../styles/churches.css'

function Churches() {
    return (

        <div>

            {/* Zoom Section */}
            <div className='zoom-container-churches d-flex justify-content-center align-items-center flex-column'>
                <div className='zoom-bg-churches'></div>
                <div className='zoom-container-span-churches-div'>
                    <span className='zoom-container-span-churches'>MINISTERIOS</span>
                    <span className='zoom-container-span-churches fw-bold'>CRISTIANOS</span>
                </div>
            </div>

            {/* Content Section */}
            <div className='container-xxl'>
                <div className='row justify-content-center align-items-center mt-5 mb-5 mx-2'>
                    <div className='col-12 col-md-10 col-lg-8'>

                        <h1 className='churches-tittle-1'>Nuestra Experiencia con</h1>
                        <h1 className='churches-tittle-2'>Ministerios Cristianos</h1>

                        <p className='churches-ph-2 pt-4'>En <span className='fw-bold'>DEFIÉNDEME - COOPSOLISERV</span> hemos tenido el privilegio de acompañar jurídicamente a distintas iglesias cristianas y ministerios en Colombia, brindando soluciones legales integrales adaptadas a sus necesidades espirituales, administrativas y comunitarias.<br /><br />
                            Durante más de 15 años de trayectoria, hemos trabajado de la mano con líderes pastorales y juntas directivas de iglesias para fortalecer su estructura legal, proteger su misión y garantizar su correcto funcionamiento ante las autoridades civiles y tributarias.
                        </p>
                    </div>
                </div>
            </div>

            {/* Content IMG */}
            <div className="container-xxl my-4 pt-4">
                <div className="row d-flex justify-content-center align-items-center">

                    <div className='col-10 col-md-4 d-flex gap-5 justify-content-center align-items-center churches-img-div'>

                        <img
                            src={`${process.env.PUBLIC_URL}/img/clients/Manantial.jpg`}
                            alt="DEFIENDEME - COOPSOLISERV"
                            className="img-fluid rounded img-churches"
                        />

                        <img
                            src={`${process.env.PUBLIC_URL}/img/clients/Presencia.png`}
                            alt="DEFIENDEME - COOPSOLISERV"
                            className="img-fluid rounded img-churches"

                        />

                        <img
                            src={`${process.env.PUBLIC_URL}/img/clients/Wesleyana.jpeg`}
                            alt="DEFIENDEME - COOPSOLISERV"
                            className="img-fluid rounded img-churches"
                        />

                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className='container-xxl pt-4'>
                <div className='row justify-content-center align-items-center mt-5 mb-5 mx-2'>
                    <div className='col-12 col-md-10 col-lg-8'>

                        <h1 className='churches-tittle-2'>¿Qué hemos hecho?</h1>

                        <ul className='churches-ph-2 pt-4'>
                            <li><span className='fw-bold'>Constitución legal de iglesias</span> ante el Ministerio del Interior, incluyendo elaboración y registro de estatutos y actas.</li>

                            <li><span className='fw-bold'>Asesoría en exenciones tributarias y trámites ante la DIAN</span>, garantizando el reconocimiento legal como entidad religiosa.</li>

                            <li><span className='fw-bold'>Acompañamiento en procesos laborales</span>, contratación formal de personal e implementación de normas de seguridad social y salud en el trabajo.</li>

                            <li><span className='fw-bold'>Defensa jurídica en situaciones penales o civiles</span>, protegiendo la integridad de pastores, miembros y bienes de la iglesia.</li>

                            <li><span className='fw-bold'>Elaboración de reglamentos internos</span>, manuales de convivencia, y actualización de personería jurídica especial.</li>

                            <li><span className='fw-bold'> Resolución de conflictos internos o comunitarios</span> mediante conciliación y mecanismos alternativos de solución.</li>

                            <li><span className='fw-bold'>Charlas legales en congregaciones</span>, orientando a líderes y feligreses sobre sus derechos y deberes jurídicos.</li>

                        </ul>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Churches
